import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneNumberCellComponent } from './phone-number-cell.component';
import { PhoneNumberModule } from '@schoolbelle/common/phone-number';


@NgModule({
  declarations: [PhoneNumberCellComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    PhoneNumberModule.forRoot(),
  ],
  exports:[PhoneNumberCellComponent],
})
export class PhoneNumberCellModule { }
